import AmpleHireInputTag from "../ample-hire-html-tags/ample-hire-input-tag";
import AmpleHireLabelTag from "../ample-hire-html-tags/ample-hire-label-tag";

const CheckboxInputField = ({
  inputTagCssClasses = "filled-in",
  inputTagIdAndName = "",
  checked = false,
  onChange = () => {},
  labelText = "",
  labelCss = "",
  ...props
}) => {
  return (
    <AmpleHireLabelTag className={labelCss} htmlFor={inputTagIdAndName}>
      <AmpleHireInputTag
        className={`filledin ${inputTagCssClasses}`}
        id={inputTagIdAndName}
        name={inputTagIdAndName}
        type={"checkbox"}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <span className="text-color-black">{labelText}</span>
    </AmpleHireLabelTag>
  );
};

export default CheckboxInputField;
